// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yBEX","col":"styles_col__UG2Sf"};